mutation UpdateAgentName($agentRegistrationId: ID!, $name: String!) {
  updateAgentName(
    input: { agentRegistrationId: $agentRegistrationId, name: $name }
  ) {
    agentRegistration {
      id
      databaseId
      name
    }
    errors
  }
}
